import React, { useState } from 'react'
import Image from 'next/image'
import Link from 'next/link'

import Divider from './divider'

const CustomHeader = ({ group }) => {
  if (group.theme === 'worldstroke') {
    return <div className='w-full h-[188px] mb-10 '>
      <a href='http://www.worldstrokecampaign.org/'>
        <Image 
          priority
          width={200} height={0}
          alt={group.name}
          sizes="(min-width: 768px) 900px, 400px"
          className='object-contain w-full block md:hidden'
          src='/wso-banner-mobile.png'
        />
        <Image 
          priority
          width={200} height={0}
          alt={group.name}
          sizes="(min-width: 768px) 900px, 400px"
          className='object-contain w-full hidden md:block'
          src='/wso-banner-web.png'
        />
      </a>
    </div>
  }
  return <></>
}

const GroupDivider = ({ group }) => {
  const [error, setError] = useState(false)
  return <>
    <CustomHeader group={group} />
    <Divider>
      {group && <div className='flex justify-center items-center'>
        {(!error && group.logo) && <div className='px-2'>
          <Image 
            width={30} height={30}
            alt={group.name}
            src={`${process.env.CDN}/${group.logo}`} 
            sizes='30vh'
            style={{ objectFit: 'contain' }}
            onError={() => setError(true)}
          />
        </div>}
        <div>
          <Link href={`/group/[id]`} as={`/group/${group.id}`} legacyBehavior>
            <div className='text-secondary cursor-pointer truncate max-w-[375px] max-[375px]:max-w-[320px] md:max-w-[825px]'>{group.name}</div>
          </Link>
        </div>
      </div>}
    </Divider>
  </>
}

export default GroupDivider
